import { MenuItem, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

const countries = [
  { code: 'BR', name: 'Brasil' },
  { code: 'US', name: 'Estados Unidos' },
  { code: 'PT', name: 'Portugal' },
  // Adicione mais países conforme necessário
];

const CountryInput = ({ control, name, label, required, error, helperText }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required && 'Campo obrigatório' }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          select
          label={label}
          fullWidth
          error={error || !!fieldState.error}
          helperText={fieldState.error?.message || helperText}
          InputLabelProps={{ shrink: true }}
        >
          {countries.map((country) => (
            <MenuItem key={country.code} value={country.name}>
              {country.name}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

CountryInput.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string
};

export default CountryInput;